const pageConfig = {
  path: '/5293/mynewsassistant.com/category',
  targeting: {
    templ: 'index',   
    configPageType: 'category-standard',
    platform: 'web,desktop',
    breakpoint: 'desktop',
    loggedin: 'undefined',
    site: 'niche',
    publication: 'mynewsassistant.com',
    mantis: 'unknown',
    iab_context: 'unknown',
    mantis_context: 'unknown',
    gs_cat: 'none',
  },
};

export default pageConfig;